module.exports = __webpack_public_path__ + "img/undraw_fill_form_re_cwyf.61ef09d8.svg";